/*
 *
 * TransactionReversePopup
 *
 * @version 1.0.0
 * @author Ivana Piscitelli
 * @since 09-Jun-2025
*/

import TransactionReversePopup from './TransactionReversePopupContainer'

export default TransactionReversePopup
